export default function ProgressBar({ current, total }) {
  const pct = total > 0 ? (current / total) * 100 : 0;
  return (
    <div className="w-full max-w-md mx-auto flex items-center gap-3">
      <div className="flex-1 h-2 rounded-full bg-gray-200 overflow-hidden">
        <div className="h-full rounded-full bg-gradient-to-r from-orange-500 to-orange-600"
             style={{ width: `${pct}%` }} />
      </div>
      <div className="text-xs text-gray-600 tabular-nums">{current}/{total}</div>
    </div>
  );
}
